export const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;